export const BASE_URL = 'https://mpat-api.mpact-int.com/api'
export const ASSET_BE_URL = 'https://mpat-api.mpact-int.com'
// export const BASE_URL = 'http://localhost:8000/api'
// export const ASSET_BE_URL = 'http://localhost:8000';



// WEBPACK FOOTER //
// ./src/constants.js